// extracted by mini-css-extract-plugin
module.exports = {"SenceCardE":"SenceCardE_SenceCardE__fvURm"};